module.exports = __webpack_public_path__ + "media/images/order_btn-b1721d4d903cdb1eb55089d47530e820.gif";